import { AnimationWithSize } from './AnimationWithSize';

export const Spreadsheet = () => (
	<AnimationWithSize src="https://dam-cdn.atl.orangelogic.com/AssetLink/e75324xa0uc61rda6s00p210neq15e57.riv" />
);
